import cn from 'classnames';
import { IBag } from '@@/bags/ts';
import { useBagMainParametersHook } from './hooks';

import styles from './index.module.sass';

export function BagMainParameters(props: IBagMainParametersProps) {
  const { className, bag, mode = 'horizontal', ...rest } = props;
  const rootClass = cn(className, styles.root, {
    [styles.root_horizontal]: mode === 'horizontal',
    [styles.root_vertical]: mode === 'vertical',
  });
  const parameters = useBagMainParametersHook(bag);

  return (
    <div className={rootClass} {...rest}>
      {parameters.map((item, index) => (
        <div key={index} className={styles.item}>
          <div className={styles.item__label}> {item.label}</div>
          <div className={styles.item__value}>{item.value}</div>
        </div>
      ))}
    </div>
  );
}

export interface IBagMainParametersProps extends React.HTMLAttributes<HTMLDivElement> {
  bag: IBag;
  mode?: 'horizontal' | 'vertical';
}
